import 'react';
import Style from './style.js';
import { jsx } from '@emotion/react';

var Avatar = _ref => {
  var {
    alt,
    size = 'small',
    src
  } = _ref;
  return jsx(Style.AvatarImage, {
    alt: alt,
    avatarSize: size,
    src: src
  });
};

export { Avatar };
